import React from 'react'
import _ from 'lodashParts'
import RichText from './richtext.jsx'
import RichTextToolbar from './toolbar/richTextToolbar.jsx'
import CkManager from '../mainController/mainController'
import constants from '../utils/constants'

const TOOLBAR_POSITION = {TOP: 'top', BOTTOM: 'bottom'}

function defaultTranslate(key) {
    return key && (constants.DEFAULT_TRANSLATIONS[key] || key)
}

class PublicApi extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            cmdStates: {
                bold: false,
                italic: false,
                underline: false,
                outdent: 0,
                indent: 0,
                bidiltr: false,
                bidirtl: false,
                justifyleft: false,
                justifyright: false,
                justifycenter: false,
                justifyblock: false,
                numberedlist: false,
                bulletedlist: false,
                fontSize: 18,
                foreColor: '#000000',
                backColor: '#FFFFFF',
                letterSpacing: 1.0,
                lineHeight: 1.0,
                fontFamily: '',
                wixLink: ''
            },
            disabled: true
        }
        this.execCommand = _.noop
        const registerTextEditorManager = manager => {
            this.manager = manager
            this.execCommand = (cmdName, params, options) => {
                this.manager.execCommand(cmdName, params, options)
            }
            manager.onCmdStateChange(cmdStates => {
                if (this.props.showToolbar) {
                    this.setState({cmdStates})
                }

                this.props.onCommandsStateChange(cmdStates)
            })

            manager.onDataChange(this.props.onDataChange)
            manager.onCopy(this.props.onCopy)
            manager.onCut(this.props.onCut)

            if (this.props.showToolbar) {
                const cmdStates = manager.getCommandsStates()

                this.setState({cmdStates, disabled: false})
            }

            this.props.onReady(manager)
        }
        this.init = domElement => {
            const initialData = this.props.initialData
            const onLoaded = manager => registerTextEditorManager(manager)
            const linksManager = this.props.linksManager
            const stylesManager = this.props.stylesManager
            const documentServicesApi = this.props.documentServicesApi
            CkManager.createInstance({
                domElement,
                initialData,
                onLoaded,
                linksManager,
                stylesManager,
                documentServicesApi,
                waitBeforeShowRichText: this.props.waitBeforeShowRichText,
                shouldInjectFontsToMainDocument: this.props.shouldInjectFontsToDocument,
                autoGrow: this.props.autoGrow,
                autoGrowOnStartup: this.props.autoGrowOnStartup,
                autoGrowMinHeight: this.props.autoGrowMinHeight,
                autoGrowMaxHeight: this.props.autoGrowMaxHeight,
                validateHtml: this.props.validateHtml
            })
        }
    }

    componentWillUnmount() {
        if (this.manager) {
            this.manager.destroy()
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !_.isEqual(nextProps, this.props) || !_.isEqual(nextState, this.state)
    }

    selectAll() {
        this.manager.selectAll()
    }

    focus() {
        this.manager.focus()
    }

    resetTheme() {
        this.manager.resetTheme()
    }

    resetThemeAndStyles() {
        this.manager.resetThemeAndStyles()
    }

    render() {
        const self = this
        function renderToolbar() {
            if (self.props.showToolbar) {
                return (
                    <RichTextToolbar
                        execCommand={self.execCommand}
                        focus={self.manager ? self.manager.focus : _.noop}
                        fonts={self.manager ? self.manager.getFonts(true) : {}}
                        themes={self.manager ? self.manager.getThemes() : {}}
                        commandStates={self.state.cmdStates}
                        disabled={self.state.disabled}
                        openLinkDialog={self.props.openLinkDialog}
                        translate={self.props.translate}
                        expandLinkSelection={self.manager ? self.manager.commands.expandCurrentLinkSelection : _.noop}
                    />
                )
            }
        }

        return (
            <div>
                {this.props.toolbarPosition === TOOLBAR_POSITION.TOP ? renderToolbar() : null}
                <RichText onLoaded={ this.init }/>
                {this.props.toolbarPosition === TOOLBAR_POSITION.BOTTOM ? renderToolbar() : null}
            </div>
        )
    }
}

PublicApi.defaultProps = {
    onCommandsStateChange: _.noop,
    onDataChange: _.noop,
    onReady: _.noop,
    onCopy: _.noop,
    onCut: _.noop,
    showToolbar: true,
    toolbarPosition: TOOLBAR_POSITION.TOP,
    shouldInjectFontsToDocument: true,
    autoGrow: true,
    autoGrowOnStartup: false,
    validateHtml: false,
    translate: defaultTranslate,
    waitBeforeShowRichText: 0
}

PublicApi.propTypes = {
    onCommandsStateChange: React.PropTypes.func,
    onDataChange: React.PropTypes.func,
    onReady: React.PropTypes.func,
    onCopy: React.PropTypes.func,
    onCut: React.PropTypes.func,
    openLinkDialog: React.PropTypes.func,
    initialData: React.PropTypes.string.isRequired,
    linksManager: React.PropTypes.object,
    stylesManager: React.PropTypes.object,
    documentServicesApi: React.PropTypes.object,
    showToolbar: React.PropTypes.bool,
    toolbarPosition: React.PropTypes.oneOf([TOOLBAR_POSITION.TOP, TOOLBAR_POSITION.BOTTOM]),
    shouldInjectFontsToDocument: React.PropTypes.bool,
    autoGrow: React.PropTypes.bool,
    autoGrowOnStartup: React.PropTypes.bool,
    autoGrowMinHeight: React.PropTypes.number,
    autoGrowMaxHeight: React.PropTypes.number,
    translate: React.PropTypes.func.isRequired,
    waitBeforeShowRichText: React.PropTypes.number
}

module.exports = PublicApi



// WEBPACK FOOTER //
// ./src/components/publicAPI.jsx